import { Grid, TextField } from '@material-ui/core'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { useContractStore } from 'context/ContractStore'
import { CollectionService } from 'lib/api/services/collection.service'
import { useSnackbar } from 'notistack'
import { useState } from 'react'

const fieldNamesInRussian = {
  countryName: 'Страна',
  oldAddressText: 'Старый адрес',
  regionName: 'Регион',
  ruralDistrictName: 'Район',
  localityName: 'Населённый пункт',
  streetName: 'Улица',
  houseNumber: 'Дом',
  apartmentNumber: 'Квартира'
}

export const AddressModal = ({ open, onClose, onCancel, getAddresses = () => {} }) => {
  const { enqueueSnackbar } = useSnackbar()
  const {
    contractStore: { contractAll }
  } = useContractStore()
  const [formData, setFormData] = useState([])

  const handleChange = event => {
    const { name, value } = event.target
    setFormData(prevData => ({ ...prevData, [name]: value }))
  }

  const handleConfirm = async () => {
    const missingFields = Object.keys(fieldNamesInRussian).filter(field => !formData[field])
    const missingFieldsInRussian = missingFields.map(field => fieldNamesInRussian[field])

    if (missingFieldsInRussian.length > 0) {
      enqueueSnackbar(`Отсутствуют поле(я): ${missingFieldsInRussian.join(', ')} 😿`, { variant: 'info' })
      return
    }

    const data = {
      ...formData,
      workListId: contractAll?.id
    }

    const res = await CollectionService.addAddress(data)

    if (res?.data) {
      enqueueSnackbar('Успешно 😸', { variant: 'success' })
      setFormData({})
      getAddresses()
      onClose()
    } else {
      enqueueSnackbar(`😿 Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
    }
  }

  return (
    <ActionModal
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      title="Добавить адрес"
      labelConfirm="Добавить"
      onConfirm={handleConfirm}
      maxWidth="md"
    >
      <Grid container spacing={2}>
        <Grid item xs={6} md={4}>
          <TextField
            name="countryName"
            label="Страна"
            placeholder="Страна"
            value={formData.countryName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <TextField
            name="oldAddressText"
            label="Старый адрес"
            placeholder="Старый адрес"
            value={formData.oldAddressText}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            name="localityName"
            label="Населённый пункт"
            placeholder="Населённый пункт"
            value={formData.localityName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <TextField
            name="regionName"
            label="Регион"
            placeholder="Регион"
            value={formData.regionName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <TextField
            name="ruralDistrictName"
            label="Район"
            placeholder="Район"
            value={formData.ruralDistrictName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <TextField
            name="streetName"
            label="Улица"
            placeholder="Улица"
            value={formData.streetName}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <TextField
            name="houseNumber"
            label="Дом"
            placeholder="Дом"
            value={formData.houseNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            name="apartmentNumber"
            label="Квартира"
            placeholder="Квартира"
            value={formData.apartmentNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      </Grid>
    </ActionModal>
  )
}
